<template>
    <div class="btn-group" role="group">
        <button class="btn btn-sm font-weight-light" type="button"
            :class="currentItem == item.id? ['btn-primary','text-white'] : ['btn-outline-primary','text-gray-disabled', 'font-xs']"
            :checked="currentItem == item.id" :key="key" @click="toggleSelected(item.id)" v-for="(item, key) in items">
            {{ item.label }}

            <span class="badge badge-pill px-1 bg-gray-disabled text-white font-xxs" v-if="item.disabled && disabledBadgeText">{{ disabledBadgeText }}</span>
        </button>
    </div>
</template>

<script>
    export default {
        props:{
            defaultItem: {
                default: false,
            },
            items: {
                default: [],
            },
            static: {
                default: false,
            },
            disabledBadgeText: {
                default: false,
            },
        },
        data:() => {
            return {
                currentItem: false
            }
        },
        created:function(){
            this.currentItem = this.defaultItem;
        },
        methods:{
            toggleSelected: function(item) {
                if(!this.static) {
                    this.currentItem = item
                }

                this.$emit('updateSelected', item)
            }
        }
    }
</script>

<style scoped>
.btn-group {
    border: 1px solid #DEDEDE;
    border-radius: 0.24rem !important;
    display: flex;
}
.btn {
    flex: 0 0 calc(100% / 3);
    border: none !important;
    border-radius: 0.1875rem !important;
    box-shadow: none !important;
}
</style>
